import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';

export function registerContentEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  register('content.plan.updated', {
    getQueryKeys: (payload) => [
      ['content', 'plan', payload.planId as string],
      ['content', 'plans', payload.familyId as string],
    ],
  });

  register('content.task.updated', {
    getQueryKeys: (payload) => [
      ['content', 'plan', payload.planId as string],
    ],
  });
}
